import Vue from 'vue'

function createFullComp(Component, props) {
  const Ctor = Vue.extend(Component)
  const comp = new Ctor({ propsData: props })

  comp.$mount()

  document.body.appendChild(comp.$el)

  comp.remove = function () {
    document.body.removeChild(comp.$el)
    comp.$destroy()
  }

  return comp
}

export default createFullComp

// // 創建函數接收要創建組件定義
// function create(Component, props) {
//   // 創建一個Vue新實例 
//   const vm = new Vue({
//     render(h) {
//       // render函數將傳入組件配置對像轉換為虛擬dom 
//       console.log(h(Component, { props }));
//       return h(Component, { props });
//     }
//   }).$mount(); //執行掛載函數，但未指定掛載目標，表示只執行初始化工作
//   // 將生成dom元素追加至body 
//   document.body.appendChild(vm.$el);

//   // 給組件實例添加銷毀方法
//   const comp = vm.$children[0]; comp.remove = () => {
//     document.body.removeChild(vm.$el);
//     vm.$destroy();
//   };
//   return comp;
// }
// // 暴露調用接口
// export default create;